import { useCallback, useReducer } from 'react';
import { NotificationActionType, NotificationType } from '../../components/notifications/types';
export const DEFAULT_TTL = 7000;
function reducer(state, action) {
  switch (action.type) {
    case NotificationActionType.ADD:
      return [action.notification, ...state];
    case NotificationActionType.REMOVE:
      return state.filter(notification => notification !== action.notification);
    case NotificationActionType.CLEAR:
      return [];
    default:
      throw new Error();
  }
}
export default function useNotificationsReducer() {
  const [notifications, dispatch] = useReducer(reducer, []);
  const add = function (message) {
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NotificationType.INFO;
    let ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_TTL;
    const notification = {
      id: Date.now(),
      type,
      message,
      ttl
    };
    dispatch({
      type: NotificationActionType.ADD,
      notification
    });
    if (ttl > 0 && Number.isFinite(ttl)) {
      setTimeout(() => {
        dispatch({
          type: NotificationActionType.REMOVE,
          notification
        });
      }, ttl);
    }
  };
  const addSuccess = useCallback(function (message) {
    let ttl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TTL;
    add(message, NotificationType.SUCCESS, ttl);
  }, []);
  const addError = useCallback(function (message) {
    let ttl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
    add(message, NotificationType.ERROR, ttl);
  }, []);
  const addWarning = useCallback(function (message) {
    let ttl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TTL;
    add(message, NotificationType.WARNING, ttl);
  }, []);
  const remove = useCallback(notification => {
    dispatch({
      type: NotificationActionType.REMOVE,
      notification
    });
  }, []);
  const clear = useCallback(() => {
    dispatch({
      type: NotificationActionType.CLEAR
    });
  }, []);
  return {
    notifications,
    add,
    addSuccess,
    addError,
    addWarning,
    remove,
    clear
  };
}
//# sourceMappingURL=useNotificationsReducer.js.map